import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import actions from './ediSetupDetails.actions.js';
import getters from './ediSetupDetails.getters.js';
import mutations from './ediSetupDetails.mutations.js';
import state from './ediSetupDetails.state.js';

BaseStore.registerModule('edipartDetails', {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
});

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('edipartDetails');

export {
	mapState,
	mapGetters,
	mapMutations,
	mapActions
};
